import Vue from 'vue'
import Vuetify from 'vuetify'
import currency from 'v-currency-field'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'

import 'tiptap-vuetify/dist/main.css'
import 'vuetify/dist/vuetify.min.css'
import pt from 'vuetify/es5/locale/pt'
import '@mdi/font/css/materialdesignicons.css'

const vuetify = new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#1976D2',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
                badDebt: '#FB3640',
                trial: '#605F5E',
                'green-blue': '#247BA0',
                bronze: '#FB8F36',
                gold: '#C2Af47',
                silver: '#A5A5A5',
            },
        },
    },
    lang: {
        locales: { pt },
        current: 'pt',
    },
    icons: {
        iconfont: 'mdi',
    },
})

Vue.use(currency)

Vue.use(Vuetify)

Vue.use(TiptapVuetifyPlugin, {
    vuetify: vuetify,
    iconsGroup: 'mdi',
})

export default vuetify
